import React, { useEffect, useState } from 'react'
import PrimaryButton from '../../jsx/components/button/primaryButton';
import './saveCardDetails.scss'
import { useDispatch, useSelector } from 'react-redux';
import { getConnectedAccountStatusById } from '../../service/api/paymentGateway/getConnectedAccountStatusById';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import ResponceForAPI from '../../component/backDrop/responcesForAPI';
import { getConnectedAccountLinkById } from '../../service/api/paymentGateway/getConnectedAccountLinkById';
import { createConnectedAccount } from '../../service/api/paymentGateway/createConnectedAccount';
import deleteConnectedAccountById from '../../service/api/paymentGateway/deleteConnectedAccountById';
import { userById } from '../../service/api/user/userById';
import { setUserDetails } from '../../feature/userData/userData';
import { Card, Modal, OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import { FaHandHoldingDollar } from 'react-icons/fa6';
import { getPayoutListById } from '../../service/api/paymentGateway/getPayoutListById';
import { getConnectedAccountBalanceByIdApi } from '../../service/api/paymentGateway/getConnectedAccountBalanceById';
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement';
import { getEarningsInformationApi } from '../../service/api/paymentGateway/getEarningsInformation';
import { setFinanceData } from '../../feature/financeData/financeData';

const AddAccountDetails = () => {
    const { connectedAccountId, impersonateFlag } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const [connectedAccStatus, setConnectedAccStatus] = useState(false);
    const [cardPaymentsCheck, setCardPaymentsCheck] = useState(false);
    const [transfersCheck, setTransfersCheck] = useState(false);

    const [connectedAccBank, setConnectedAccBank] = useState('');
    const [connectedAccCurrency, setConnectedAccCurrency] = useState('');
    const [connectedAccLast4, setConnectedAccLast4] = useState('');

    const [connectedAccsArr, setConnectedAccsArr] = useState([]);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [apiResponce, setApiResponse] = useState(false);

    const [distinationAccId, setDistinationAccId] = useState('');

    const [availableBalanceObj, setAvailableBalanceObj] = useState({});

    useEffect(() => {
        if (connectedAccountId) {
            getConnectedAccountStatus();

            // getConnectedAccountBalanceByIdFn();
            getEarningsInformationFn();
        }
    }, [])

    const getConnectedAccountStatus = () => {
        let details = {
            connected_account_id_ids: connectedAccountId,
        }
        dispatch(
            getConnectedAccountStatusById(details,
                (res) => {
                    // console.log(res?.data?.data)
                    // console.log(res?.data?.data?.connected_account_status)
                    setConnectedAccStatus(res?.data?.data?.connected_account_status)
                    if (res?.data?.data?.connected_account_details.capabilities.card_payments === "active") { setCardPaymentsCheck(true) }
                    if (res?.data?.data?.connected_account_details.capabilities.transfers === "active") { setTransfersCheck(true) }

                    setConnectedAccsArr(res?.data?.data?.connected_account_details?.external_accounts?.data);
                    setConnectedAccBank(res?.data?.data?.connected_account_details.external_accounts.data[0].bank_name)
                    setConnectedAccCurrency(res?.data?.data?.connected_account_details.external_accounts.data[0].currency.toUpperCase())
                    setConnectedAccLast4(res?.data?.data?.connected_account_details.external_accounts.data[0].last4)
                    setDistinationAccId(res?.data?.data?.connected_account_details?.external_accounts.data[0].id)

                    // console.log(connectedAccBank, connectedAccCurrency, connectedAccLast4)
                },
                (res) => {
                    // console.log(res?.data)
                })
        )
    }
    // console.log(connectedAccBank, connectedAccCurrency, connectedAccLast4)


    const openUpdateStripeAccPage = () => {
        setApiResponse(true);

        let details = {
            connected_account_id_ids: connectedAccountId,
        }
        dispatch(
            getConnectedAccountLinkById(details,
                (res) => {
                    // console.log(res.data.data)
                    window.open(res.data.data, "_target");

                    setApiResponse(false);
                    // setResponceMsg(res.data.message)
                    // setToasterType("success")

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setApiResponse(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
        )
    }

    const addNewAccount = () => {
        let details = new FormData();
        setApiResponse(true);

        details.append("user_id_ids", localStorage.getItem("user_id"));

        dispatch(
            createConnectedAccount(
                details,
                (res) => {
                    // console.log(res)
                    window.open(res.data.data.connected_account_link, "_target");
                    setApiResponse(false);
                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setApiResponse(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    // This will delete all the accounts connected by professional
    const deleteConnectedAccount = () => {
        setApiResponse(true);

        let details = new FormData();

        details.append("connected_account_id_ids", connectedAccountId);
        details.append("user_id_ids", localStorage.getItem('user_id'));

        dispatch(
            deleteConnectedAccountById(
                details,
                (res) => {
                    // console.log(res)
                    setActivePopoverAcc(null);
                    setApiResponse(false);
                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    let details = {
                        user_id_ids: localStorage.getItem('user_id'),
                        role_id_int: localStorage.getItem("roleId"),
                        user_impersonate_flag: 0
                    }
                    dispatch(
                        userById(details, (res) => {
                            dispatch(setUserDetails(res.data.data))
                        }),
                    )

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setApiResponse(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    const [activePopoverAcc, setActivePopoverAcc] = useState(false);
    // More actions for both customer and pro
    const popoverConnectedAcc = (index) => (
        <Popover
            id={`popover-basic-${index}`}
            style={{ minWidth: "100px", border: 'none' }}
        >
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
                }}>
                <div className="d-flex flex-column font-w500 fs-6"

                >
                    <div
                        onClick={(e) => {
                            // handleOpenUpdateCard(cardObject, false);
                            // setActivePopoverCard(null)
                            openUpdateStripeAccPage()
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                        style={{
                            pointerEvents: apiResponce ? "none" : "auto",
                            opacity: apiResponce ? "0.5" : '1',
                        }}
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>Update</span>
                    </div>

                    <div
                        onClick={(e) => {
                            // setActivePopoverAcc(null);
                            // deleteConnectedAccount();
                            openUpdateStripeAccPage()
                        }}
                        className=' cursor-pointer p-2 text-danger overlay-action-btn'
                        style={{
                            pointerEvents: apiResponce ? "none" : "auto",
                            opacity: apiResponce ? "0.5" : '1',
                        }}
                    >
                        <span className='me-2'>
                            {/* {apiResponce ?
                                <Spinner animation="border" size="sm" /> :
                                <i className="bi bi-trash"></i>
                            } */}
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>Delete</span>
                    </div>
                </div>

            </Popover.Body>
        </Popover>
    );

    // View payment history functions
    const [viewPayoutHistoryTrigger, setViewPayoutHistoryTrigger] = useState(false);
    const [viewPayoutHistoryFlag, setViewPayoutHistoryFlag] = useState(false);
    const [payoutHistoryArrPro, setPayoutHistoryArrPro] = useState([]);
    const [payoutHistroyLoading, setPayoutHistroyLoading] = useState(false);
    const handleOpenViewPayoutHistory = () => {
        setViewPayoutHistoryTrigger(true);
        setViewPayoutHistoryFlag(true);
    }
    const handleCloseViewPayoutHistory = () => {
        setViewPayoutHistoryTrigger(false);
    }

    const getPayoutListByIdFn = () => {
        setPayoutHistroyLoading(true);
        // let data = {
        //     connected_account_id_ids: connectedAccountId,
        //     destination_id_ids: distinationAccId,
        // }

        let data  = new FormData();
        data.append("status_chr", 'all');
        dispatch(
            getPayoutListById(data,
                (res) => {
                    setPayoutHistroyLoading(false);
                    // console.log(res.data.data.data, 'ajkshdagduyd');
                    setPayoutHistoryArrPro(res.data.data.data)
                },
                (res) => {
                    setPayoutHistroyLoading(false);
                    // console.log(res)
                })
        )
    }

    useEffect(() => {
        if (viewPayoutHistoryFlag && connectedAccountId) {
            getPayoutListByIdFn();
        }
    }, [viewPayoutHistoryFlag]);


    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    function convertUnixTime(unixTime) {
        // Create a new Date object from the Unix timestamp
        // Note: Unix timestamp should be in milliseconds for JavaScript Date object,
        // so we multiply by 1000 (because Unix timestamp is usually in seconds).
        const date = new Date(unixTime * 1000);

        // Define an array of month names to convert month number to month name
        const months = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        // Extract the day, month and year from the date
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        // Return the formatted date string
        return `${month} ${day}, ${year}`;
    }

    const getConnectedAccountBalanceByIdFn = () => {
        let data = {
            connected_account_id_ids: connectedAccountId,
        }
        dispatch(
            getConnectedAccountBalanceByIdApi(data,
                (res) => {
                    // console.log(res.data.data);
                    setAvailableBalanceObj(res.data.data)
                },
                (res) => {
                    // console.log(res)
                })
        )
    }

    // new functions for the earnings
    const getEarningsInformationFn = () => {
        let details = {};
        dispatch(
            getEarningsInformationApi(
                details,
                (res) => {

                    // res?.data?.data?.pro_transaction_list && setTransactionList(res?.data?.data?.pro_transaction_list);
                    // res?.data?.data?.pro_payment_list && setPaymentListArr(res?.data?.data?.pro_payment_list);
                    dispatch(setFinanceData(res?.data?.data))

                    // console.log(res?.data?.data?.connected_account_balance_info, 'connected_account_balance_info')
                    setAvailableBalanceObj(res?.data?.data?.connected_account_balance_info);

                },
                (res) => {
                    // console.log(res?.data?.data);
                }
            )
        );
    };


    return (
        <>
            <Card className='border  card w-100 bg-white' >
                {/* New Ui */}
                <div className='row mx-0  w-100 h-100'>
                    <div className='col-12 d-flex flex-column justify-content-between lh-lg p-4' style={{}}>
                        <div>
                            <div className='row mx-0'>
                                <div className='align-items-center col-12 d-flex fs-3 fw-bold justify-content-center px-0'>
                                    <span className='align-items-center border d-flex fs-4 justify-content-center me-2 rounded-circle' style={{ height: '25px', width: '25px' }}>
                                        <FaHandHoldingDollar />
                                    </span>
                                    <span>{"Get paid"}</span>
                                </div>
                            </div>

                            <div className='row mx-0 mb-4'>
                                <div className='align-items-center col-12 d-flex font-w500 justify-content-center px-0 text-black'>
                                    <span>{"Your payout methods"}</span>
                                </div>
                            </div>


                            <div>
                                {!connectedAccountId ?
                                    <div className='row mx-0 mb-2'>
                                        <div className='col-12 px-0'>
                                            <span>
                                                {"To get the payouts from the Chilll LC, please add your bank/debit card details."}
                                            </span>
                                        </div>
                                    </div> :
                                    (connectedAccountId || !connectedAccStatus) && !cardPaymentsCheck && !transfersCheck ?
                                        <div className='row mx-0 mb-2'>
                                            <div className='col-12 px-0'>
                                                <span>
                                                    {"To get the payouts from the Chilll LC, please fill your bank/debit card details completely."}
                                                </span>
                                            </div>
                                        </div> :
                                        connectedAccountId && connectedAccStatus && cardPaymentsCheck && transfersCheck ?
                                            <>
                                                <div className='row mx-0 mb-2'>
                                                    <div className='col-12 px-0'>
                                                        <span>
                                                            {"Your account setup is successfully completed you will receive payouts in registered account."}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div>
                                                    {connectedAccsArr.map((element, index) => {
                                                        return (
                                                            <>
                                                                <div className='row mx-0' key={index}>
                                                                    <div className='col-12 mb-2 p-3 border shadow-sm'>

                                                                        <div className='row mx-0'>
                                                                            <div className='col-12  px-0 d-flex justify-content-between align-items-center'>
                                                                                <div className='font-w600 mb-1 row text-success'>
                                                                                    {element?.default_for_currency && <span>{"Primary payout method"}</span>}
                                                                                </div>


                                                                                <div className='fs-5 fw-bold mb-1'>

                                                                                    <div className="tooltipCustom">
                                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"More"}</span>
                                                                                        <span
                                                                                            className='d-flex align-items-center justify-content-center more-option rounded-circle'
                                                                                            style={{ height: '20px', width: '20px' }}
                                                                                            onClick={() => {
                                                                                                // handleMenuClick(element, index)
                                                                                            }}
                                                                                        >
                                                                                            <OverlayTrigger
                                                                                                trigger="click"
                                                                                                placement="bottom"
                                                                                                overlay={popoverConnectedAcc(index)}
                                                                                                rootClose={true}
                                                                                                show={activePopoverAcc === index}
                                                                                                onToggle={(show) => setActivePopoverAcc(show ? index : null)}
                                                                                            >
                                                                                                <i class="bi bi-three-dots-vertical cursor-pointer"></i>
                                                                                            </OverlayTrigger>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>

                                                                        <div className='row mx-0'>
                                                                            <div className='col-12  px-0 d-flex align-items-center'>
                                                                                <div className='bg-light text-black fs-2 d-flex align-items-center justify-content-center p-2' style={{ height: '50px', width: '50px' }}>
                                                                                    <i className="bi bi-bank2"></i>
                                                                                </div>
                                                                                <div className='d-flex flex-column ps-3'>
                                                                                    <div className='d-flex'>
                                                                                        <span className='fw-bold text-black fs-5 pe-2'>{`${element?.bank_name}`}</span>
                                                                                        <span className='fw-bold fs-6 bg-gray rounded-2 bg-light px-3 d-flex align-items-center'>{`${element?.currency?.toUpperCase()}`}</span>
                                                                                    </div>

                                                                                    <div className='d-flex font-w600'>
                                                                                        <span>{`****${element?.last4}`}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })

                                                    }
                                                </div>
                                            </> : ''
                                }
                            </div>

                            <div className='border col-12 mb-2 p-3 shadow-sm bg-light'>
                                <div className='row mx-0'>

                                    <div className='align-items-center col-3 d-flex justify-content-center px-0'>
                                        <div className='align-items-cente bg-white border d-flex fs-2 justify-content-center rounded-circle text-black' style={{ height: '3rem', width: '3rem', }}>
                                            <i class="align-self-center bi bi-gear-wide-connected"></i>
                                        </div>
                                    </div>

                                    <div className='col-9 px-0 d-flex align-items-center'>
                                        <div className='d-flex fs-5 row'>
                                            <div className='col-12'>
                                                <span className='fw-500'>{`Wallet balance: `}</span>
                                                <span className='fw-bold text-success'>{`${USDollar.format((availableBalanceObj?.available?.[0]?.amount / 100) || 0)}`}</span>
                                            </div>
                                        </div>
                                        {/* <div className='font-w500 mb-1 row text-black'>
                                            <span>{"Get paid now"}</span>
                                        </div> */}
                                    </div>


                                </div>
                            </div>


                        </div>

                        <div className='row mx-0 pt-5 '>
                            <div className='col-12 px-0'>
                                <div className='row mx-0'>
                                    <div className='col-8  px-0'>
                                        <div
                                            className='d-flex'
                                            style={{
                                                pointerEvents: apiResponce ? "none" : "auto",
                                                opacity: apiResponce ? "0.5" : '1',
                                            }}
                                        >
                                            {!connectedAccountId ?
                                                <div onClick={() => { addNewAccount() }} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                                    <span>{"Add a new payout method"} </span>
                                                    {/* <i className="bi bi-chevron-right ps-2 hovered-arrow"></i> */}
                                                </div> :
                                                (connectedAccountId || !connectedAccStatus) && !cardPaymentsCheck && !transfersCheck ?
                                                    <div onClick={() => { openUpdateStripeAccPage() }} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                                        <span>{"Complete your account setup"} </span>
                                                        {/* <i className="bi bi-chevron-right ps-2 hovered-arrow"></i> */}
                                                    </div> :
                                                    (connectedAccountId || connectedAccStatus) && cardPaymentsCheck && transfersCheck ?
                                                        <div onClick={() => { openUpdateStripeAccPage() }} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                                            <span>{"Add a new payout method"} </span>
                                                            {/* <i className="bi bi-chevron-right ps-2 hovered-arrow"></i> */}
                                                        </div>
                                                        : ''
                                            }
                                        </div>
                                    </div>
                                    <div className='col-4'></div>
                                </div>
                                
                                {/* {connectedAccountId && connectedAccStatus && cardPaymentsCheck && transfersCheck &&
                                    <div className='row mx-0'>
                                        <div className='col-8  px-0'>
                                            <div className='d-flex'>
                                                <div onClick={() => { handleOpenViewPayoutHistory() }} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                                    <span>{"View payout history"} </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-4'></div>
                                    </div>
                                } */}

                            </div>
                        </div>
                    </div>
                </div>



            </Card>

            {/* Modal for view payout history */}
            <Modal className="fade" show={viewPayoutHistoryTrigger} centered>
                <Modal.Body style={{ minHeight: '40dvh', maxHeight: '70dvh' }}>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseViewPayoutHistory()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4 pb-2 border-bottom'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Payout history"}
                                        </span>
                                    </div>
                                </div>



                                {/* View payment history for customer */}

                                <>
                                    <div className='h-100 overflow-auto' style={{ maxHeight: '50dvh' }}>

                                        {payoutHistroyLoading ?
                                            <>
                                                <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                            </> : <>
                                                {payoutHistoryArrPro?.length > 0 ?
                                                    <>
                                                        {
                                                            payoutHistoryArrPro?.map((element, index) => {
                                                                return (
                                                                    <>
                                                                        <div key={index} className='row mx-0 border-bottom py-3'>
                                                                            <div className='col-12 px-0'>
                                                                                <div className='row mx-2 mb-1'>
                                                                                    <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                                                                        <div className='font-w500 text-black'>
                                                                                            <span>{`Withdrawal to your bank account.`}</span>
                                                                                        </div>

                                                                                        <div className='font-w600 text-black'>
                                                                                            <span>{`${USDollar.format(element?.amount / 100)}`}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className='row mx-2'>
                                                                                    <div className='col-12 px-0 mb-1 d-flex justify-content-between align-items-center'>
                                                                                        <div>
                                                                                            <span>{`${convertUnixTime(element?.created)}`}</span>
                                                                                        </div>

                                                                                        <div>
                                                                                            {/* <span>{`Service fee `}</span>
                                                                                            <span className='font-w600 text-black'>{`$0.00`}</span> */}
                                                                                            {
                                                                                                <span
                                                                                                    title={`${element?.status === 'failed' ? element?.failure_message : ''}`}
                                                                                                    className={`${element?.status === 'failed' ? 'text-danger' : element?.status === 'paid' ? 'text-success' : 'text-primary'}`}
                                                                                                >
                                                                                                    {element?.status}
                                                                                                </span>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                        }

                                                    </>
                                                    :
                                                    <div className='row mx-0 h-100'>
                                                        <div className='col-12 px-0 h-100 d-flex justify-content-center align-items-center'>
                                                            <span>
                                                                {"No payout history"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            </>}
                                    </div>
                                </>

                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>


            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
            {/* {apiResponce && <ResponceForAPI show={apiResponce} />} */}


            {/* Payout old design */}
            {/* <div className='row mx-0  w-100 h-100'>
                <div className='col-12 d-flex flex-column justify-content-between lh-lg p-4' style={{}}>
                    <div>
                        <div className='row mx-0'>
                            <div className='align-items-center col-12 d-flex fs-3 fw-bold justify-content-center px-0'>
                                <span className='align-items-center border d-flex fs-4 justify-content-center me-2 rounded-circle' style={{ height: '25px', width: '25px' }}>
                                    <FaHandHoldingDollar />
                                </span>
                                <span>{"Get paid"}</span>
                            </div>
                        </div>

                        <div className='row mx-0 pb-2'>
                            <div className='align-items-center col-12 d-flex font-w500 justify-content-center px-0 text-black'>
                                <span>{"Your payout methods"}</span>
                            </div>
                        </div>

                        <div className='bg-white border col-12 mb-2 p-3 shadow-sm'>
                            <div className='row mx-0'>
                                <div className='col-11  px-0 '>
                                    <div className='font-w600 mb-1 row'>
                                        <span>{"Primary payout method"}</span>
                                    </div>

                                    <div className='d-flex fs-5 fw-bold row text-black'>
                                        <div className='col-12'>
                                            <span>{`Bank account - **US`}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-1  px-0 text-black'>
                                    <div className='fs-5 fw-bold row mb-1'>

                                        <div className="tooltipCustom">
                                            <span className="tooltiptextCustom w-100">{"More"}</span>
                                            <span className='d-flex align-items-center justify-content-center more-option rounded-circle'>
                                                <OverlayTrigger
                                                    key={index}
                                                    trigger="click"
                                                    placement="bottom"
                                                    // overlay={popover}
                                                    overlay={popover(index)}
                                                    rootClose={true}
                                                    show={activePopover === index}
                                                    onToggle={(show) => setActivePopover(show ? index : null)}
                                                >
                                                    <i onClick={() => { }} class="bi bi-three-dots-vertical cursor-pointer"></i>
                                                </OverlayTrigger>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='border col-12 mb-2 p-3 shadow-sm bg-light'>
                            <div className='row mx-0'>

                                <div className='align-items-center col-3 d-flex justify-content-center px-0'>
                                    <div className='align-items-cente bg-white border d-flex fs-2 justify-content-center rounded-circle text-black' style={{ height: '3rem', width: '3rem', }}>
                                        <i class="align-self-center bi bi-gear-wide-connected"></i>
                                    </div>
                                </div>

                                <div className='col-9 px-0 '>
                                    <div className='d-flex fs-5 row'>
                                        <div className='col-12'>
                                            <span className='fw-500'>{`Balance: `}</span>
                                            <span className='fw-bold text-black'>{`$0.00`}</span>
                                        </div>
                                    </div>
                                    <div className='font-w500 mb-1 row text-black'>
                                        <span>{"Get paid now"}</span>
                                    </div>
                                </div>


                            </div>
                        </div>


                    </div>

                    <div className='row mx-0 pt-5 '>
                        <div className='col-12 px-0'>
                            <div className='row mx-0'>
                                <div className='col-8  px-0'>
                                    <div className='d-flex'>
                                        <div onClick={() => { }} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                            <span>{"Add a new payout method"} </span>
                                            <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-4'></div>
                            </div>
                            <div className='row mx-0'>
                                <div className='col-8  px-0'>
                                    <div className='d-flex'>
                                        <div onClick={() => { }} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                            <span>{"View payout history"} </span>
                                            <i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-4'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default AddAccountDetails;